var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title-bar'),_c('app-card',{attrs:{"heading":_vm.$t('message.wysiwyg')}},[_c('wysiwyg',{model:{value:(_vm.myHTML),callback:function ($$v) {_vm.myHTML=$$v},expression:"myHTML"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }